<template>
    <div class="relative aspect-video">
        <audio
            class="absolute top-0 left-0 w-full h-full"
            width="100%"
            height="100%"
            controls
            :src="currentFile ? currentFile.src : ''"
        ></audio>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "FileAudio",
    computed: {
        ...mapGetters("player/view", ["currentFile"]),
    },
};
</script>
